import { render, staticRenderFns } from "./ExcelYuklemeCard.vue?vue&type=template&id=46652bae&scoped=true"
import script from "./ExcelYuklemeCard.vue?vue&type=script&lang=ts"
export * from "./ExcelYuklemeCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46652bae",
  null
  
)

export default component.exports